import React from 'react';
import { AlertCircle } from 'lucide-react';

function suggestionTitle(suggestion) {
  const count = suggestion.contractCount || 0;
  const score = typeof suggestion.score === 'number'
    ? ` · match ${Math.round(suggestion.score * 100)}%`
    : '';

  return `${count} existing contract${count === 1 ? '' : 's'}${score}`;
}

export default function CounterpartySuggestionCallout({
  onDismiss,
  onUse,
  suggestions,
}) {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="callout yellow" style={{ marginTop: 8 }}>
      <AlertCircle className="w-4 h-4" style={{ color: 'var(--text-yellow)', flexShrink: 0, marginTop: 1 }} />
      <div className="callout-body">
        <div style={{ fontSize: 12, marginBottom: 6 }}>
          Similar counterparty already exists — pick one to avoid splitting Drive folders:
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {suggestions.map((suggestion) => (
            <button
              key={suggestion.name}
              type="button"
              onClick={() => onUse(suggestion)}
              className="btn outline xs"
              title={suggestionTitle(suggestion)}
            >
              Use “{suggestion.name}”
              <span style={{ color: 'var(--text-tertiary)', marginLeft: 4 }}>
                ({suggestion.contractCount || 0})
              </span>
            </button>
          ))}
          <button
            type="button"
            onClick={onDismiss}
            className="btn ghost xs"
          >
            Keep as typed
          </button>
        </div>
      </div>
    </div>
  );
}
